import { render, staticRenderFns } from "./ShopTime.vue?vue&type=template&id=2c41965f&scoped=true&"
import script from "./ShopTime.vue?vue&type=script&lang=js&"
export * from "./ShopTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41965f",
  null
  
)

component.options.__file = "ShopTime.vue"
export default component.exports